<a class="volver" routerLink="/compromisos-comunidades">
  <svg width="14" height="8" ...>...</svg>
  <span>Compromisos de Comunidades</span>
</a>

<div class="subheader">
  <div class="text">
    <h1>Compromisos Comunidad<br />{{ currentFilter }}</h1>
  </div>
  <div class="image">
    <img class="imagenComunidad" [src]="image" [alt]="currentFilter" />
  </div>
</div>

<!-- Waves → (tu SVG intacto) -->
<svg id="wave" ...>...</svg>

<div class="containerList">
  <ul class="commitments-list">
    <!-- Header -->
    <li class="commitment-header">
      <h3>Titulo</h3>
      <h3>Aplica a</h3>
      <h3>ODS a los que aplica</h3>
      <h3>Dimensiones</h3>
    </li>

    <!-- Items -->
    <li
      class="commitment-item"
      *ngFor="let compromiso of compromisosFiltrados; trackBy: trackByCode"
    >
      <a [routerLink]="'/compromisos/' + compromiso.code + '/detalle'">
        <h4>{{ compromiso.title }}</h4>

        <div class="appliesTo">
          <app-svg-icon
            iconType="person"
            [color]="compromiso.appliesToPersons ? 'currentColor' : '#cfcfcf'"
            matTooltip="Personas"
          ></app-svg-icon>

          <app-svg-icon
            iconType="company"
            [color]="compromiso.appliesToCompanies ? 'currentColor' : '#cfcfcf'"
            matTooltip="Empresas"
          ></app-svg-icon>

          <app-svg-icon
            iconType="service"
            [color]="compromiso.appliesToServices ? 'currentColor' : '#cfcfcf'"
            matTooltip="Aplicaciones"
          ></app-svg-icon>
        </div>

        <app-ods-display
          [sustainableDevelopmentGoals]="compromiso.sustainableDevelopmentGoals"
          [commitmentCode]="compromiso.code"
        ></app-ods-display>

        <div class="dimensiones">
          <app-svg-icon
            iconType="ambiente"
            [color]="compromiso.dimensionE ? 'currentColor' : '#cfcfcf'"
            matTooltip="Ambiente"
          ></app-svg-icon>

          <app-svg-icon
            iconType="social"
            [color]="compromiso.dimensionS ? 'currentColor' : '#cfcfcf'"
            matTooltip="Social"
          ></app-svg-icon>

          <app-svg-icon
            iconType="gobernanza"
            [color]="compromiso.dimensionG ? 'currentColor' : '#cfcfcf'"
            matTooltip="Gobernanza"
          ></app-svg-icon>
        </div>
      </a>
    </li>
  </ul>
</div>
